.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  .loading-container {
    background-color: var(--grey-layout-020);
    top: 0;
    left: 0;
    position: absolute;
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    z-index: 9000000;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .form-wrapper {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }
}